import MinigridListView from './MinigridListView/MinigridListView'
import useMinigrid from '../../../hook'
import { useNavigate } from 'react-router-dom'
import Pagination from '../../../../../common/components/organisme/Pagination/Pagination'
import { useCapability } from '../../../../rbac'



export default function MinigirdListPresenter() {

    const {allMinigridQuery: {data, isLoading, isError, error, setPage}, deleteMinigrid} = useMinigrid()

    const navigate = useNavigate()
    const canEdit = useCapability('equipment.edit')
    const canDelete = useCapability('minigrid.delete')

    const handleDelete = (minigridId: string) => {
        deleteMinigrid.mutate({minigridId})
    }

    const goToSingleMinigrid = (minigridId: string) => {

      navigate(`/main/minigrid/${minigridId}`)
    }

    const goToEdit = (minigridId: string) => {
      navigate(`/main/minigrid/${minigridId}/edit`)
    }


    if(isError){
  
        console.log(error)
        return <div>{error.message } status {error.response?.status}</div>
    }
  return (
    <>
    <MinigridListView minigridList={data?.data} deleteMinigridHandler={canDelete ? handleDelete : undefined} goToSingleMinigrid={goToSingleMinigrid} goToEditMinigrid={canEdit ? goToEdit : undefined} isLoading={isLoading} />
    { !isLoading &&
    <Pagination  centered currentPage={data?.pagination.current_page} lastPage={data?.pagination.total_pages} setCurrentPage={setPage}/>
  }
    </>
  )
}
